import { render, staticRenderFns } from "./WithdrawalHistories.vue?vue&type=template&id=73e95880&scoped=true&"
import script from "./WithdrawalHistories.vue?vue&type=script&lang=ts&"
export * from "./WithdrawalHistories.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawalHistories.vue?vue&type=style&index=0&id=73e95880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e95880",
  null
  
)

export default component.exports